import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Spinner, ConfirmDialog } from '../common/Helper';
import { formatSecs, paginatedFetch, fetchData, iAxios } from '../../lib/utils'
import Icon from '../ds/Icon';
import ReactMarkdown from 'react-markdown';

const Poker = () => {

    const [issueList, setIssueList] = useState(null);
    const [plan, setPlan] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [confirmDel, setConfirmDel] = useState(null);
    const { product } = useParams();
    const user = useSelector(st => st.userInfo);

    const deleteIssue = (item) => {
        iAxios.post('/api/v1/tickets/delete', { id: item.id }).then(() => {
            setIssueList(list => (list || []).filter(i => i.id !== item.id));
            setConfirmDel(null);
        }).catch(ex => {
            alert(ex.message);
            setConfirmDel(null);
        });
    };

    const loadData = (force = 0) => {
        fetchData(`/api/v1/plan/poker-play`, {
            force: force,
            project: product,
        }).then(resp => {
            setPlan(resp.data.data);
        }).catch(ex => {
            console.error("Error XXX:", ex);
        });
    };

    const fetchIssues = (mode = 'normal') => {
        setIssueList(null);
        setPlan(null);
        setErrorMessage(null);
        paginatedFetch('/api/v1/tickets/list', {
            project: product,
            mode: mode,
            milestone: 'all',
        }).then(res => {
            const result = res.data;
            result.sort((a, b) => a.timeEstimate - b.timeEstimate);
            setIssueList(result);
            loadData();
        }).catch(ex => {
            console.error('Error : Poker: 51 ', ex);
            alert(ex.message);
        });
    };

    useEffect(() => {
        fetchIssues();
        loadData();
    }, []);

    const setError = (result) => {
        if (result.status) {
            return;
        }
        setErrorMessage(result.message);
        setTimeout(() => setErrorMessage(null), 5000);
    };

    const playPoker = (value) => {
        iAxios.post('/api/v1/plan/poker-issue', { value, project: product }).then(resp => {
            setError(resp.data);
            setPlan(resp.data.data);
        });
    };

    const handleIssue = (issue) => {
        iAxios.post('/api/v1/plan/poker-issue', { issue, project: product })
            .then(resp => {
                setError(resp.data);
                setPlan(resp.data.data);
            }).catch(() => { });
    };

    const renderIssue = () => {
        if (!plan) {
            return null;
        }
        const vals = [1, 2, 3, 5, 8, 13, 21];

        return (
            <div className="ds-panel">
                <div className="ds-panel__head"><h3 className="ds-panel__title">Estimate</h3></div>
                <div className="ds-panel__body">
                    {errorMessage && <div className="login__error" role="alert">{errorMessage}</div>}

                    <div className="ds-table-wrap">
                        <table className="ds-table">
                            <thead>
                                <tr><th>Player</th><th>Estimate</th></tr>
                            </thead>
                            <tbody>
                                {plan.poker && Object.keys(plan.poker).map(email =>
                                    <tr key={email}><td>{email}</td><td className="ds-nums">{plan.poker[email]}</td></tr>)}
                            </tbody>
                        </table>
                    </div>

                    {plan.poker && <button onClick={() => loadData(1)} className="ds-btn is-soft is-block" style={{ marginTop: 'var(--ds-space-4)' }}>Refresh</button>}

                    {!plan.poker && plan.issue && (
                        <div className="poker-vals">
                            {vals.map(item => (
                                <button key={item} type="button" value={item} onClick={() => playPoker(item)} className="ds-btn is-primary">
                                    {item}
                                </button>
                            ))}
                        </div>
                    )}

                    {plan.issue
                        ? <div style={{ marginTop: 'var(--ds-space-4)' }}>
                            <h3>{plan?.issue?.title}</h3>
                            <ReactMarkdown className="cgs-markdown">{plan.issue.description}</ReactMarkdown>
                        </div>
                        : <h4 style={{ marginTop: 'var(--ds-space-4)', color: 'var(--ds-ink-muted)' }}>Select an issue</h4>}
                </div>
            </div>
        );
    };

    return (
        <div>
            <div className="page-head"><h2>Planning Poker</h2>
                <span className="ds-panel__sub">Plan your estimates without bias</span>
            </div>

            {!issueList && <Spinner />}

            <div className="split-even">
                <div className="ds-panel">
                    <div className="ds-panel__head"><h3 className="ds-panel__title">Backlog</h3></div>
                    <div className="ds-table-wrap scroll-pane">
                        <table className="ds-table">
                            <tbody>
                                {issueList && issueList.map((item, idx) => (
                                    <tr key={idx} style={{ cursor: 'pointer' }} onClick={() => handleIssue(item)}>
                                        <td className="ds-nums">{idx + 1}</td>
                                        <td>
                                            <div style={{ fontWeight: 'var(--ds-weight-medium)' }}>{item.title}</div>
                                            <div className="issue-tags" style={{ alignItems: 'center' }}>
                                                <span style={{ color: 'var(--ds-ink-muted)', fontSize: 'var(--ds-text-xs)', marginRight: 'auto' }}>{item.assignee?.name}</span>
                                                {item.timeEstimate > 0 && <span className="issue-tag">{formatSecs(item.timeEstimate)}</span>}
                                                {item.weight && <span className="issue-tag is-project">{item.weight}</span>}
                                                {item.labels.map(lb => <span key={lb} className="issue-tag">{lb}</span>)}
                                                <a target="_blank" rel="noreferrer" className="ds-btn is-ghost is-sm" href={`${item.url}`} onClick={(e) => e.stopPropagation()}>View</a>
                                                {user?.role === 'Admin' && (
                                                    <button
                                                        type="button"
                                                        className="ds-btn is-ghost is-sm is-icon"
                                                        aria-label="Delete issue"
                                                        title="Delete issue"
                                                        onClick={(e) => { e.stopPropagation(); setConfirmDel(item); }}
                                                    >
                                                        <Icon name="trash" />
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div>{renderIssue()}</div>
            </div>

            <ConfirmDialog
                open={!!confirmDel}
                title="Delete issue?"
                message={confirmDel ? `"${confirmDel.title}" will be permanently deleted.` : ''}
                confirmLabel="Delete"
                danger
                onConfirm={() => deleteIssue(confirmDel)}
                onCancel={() => setConfirmDel(null)}
            />
        </div>
    );
};

export default Poker;
